module.exports = __webpack_public_path__ + "img/1f973.ea54191.svg";